export enum StopType {
  Pick = 'Pick',
  Drop = 'Drop'
}
